<template>
	<div class="container__normaltable">
		<div
			v-if="data.length === 0"
			class="container__normaltable__empty"
		>
			<p>{{ tableConfiguration.statusTable }}</p>
		</div>
		<table v-else>
			<thead>
				<tr>
					<td v-show="!reportMode">
						<Checkbox v-model="isDeleteAllPageData" />
					</td>
					<td
						v-for="header in headersFiltered"
						:key="header.key"
					>
						{{ header.value }}
						<div v-if="showSortOptions">
							<i
								v-if="sortBy === header.key && sortType === 'desc'"
								class="fas fa-sort-up cursor-pointer"
								@click="changeSort(header.key, 'asc')"
							/>
							<i
								v-else-if="sortBy === header.key && sortType === 'asc'"
								class="fas fa-sort-down cursor-pointer"
								@click="changeSort(header.key, undefined)"
							/>
							<i
								v-else
								class="fas fa-sort cursor-pointer"
								@click="changeSort(header.key, 'desc')"
							/>
						</div>
					</td>
					<td />
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(dataObject, key) in data"
					:key="key"
				>
					<td v-show="!reportMode">
						<Checkbox
							v-model="dataObject.isCheckedToDelete"
							:disabled="dataObject.isBlocked"
						/>
					</td>

					<td
						v-for="(dataValue, propertie, key) in getPropertiesMapped(dataObject)"
						:key="key"
					>
						<span
							v-if="isToRenderATag(propertie)"
							class="container__normaltable__tags"
						>
							<Tag
								:class-name="tableConfiguration.tags[propertie][dataValue]"
								:label="dataValue"
							/>
						</span>

						<span v-else-if="isToRenderAProgressBar(propertie)">
							<ProgressBar
								:key="dataObject.id"
								:progresso-atual="dataValue"
							/>
						</span>

						<span v-else-if="isToRenderAColorIndicator(propertie)">
							<div
								:style="{
									height: '16px',
									width: '16px',
									background: dataValue,
									borderRadius: '50%',
									margin: '0 auto',
								}"
							/>
						</span>

						<!-- Adicionando o componente OfficialProcessingIcon na coluna Status -->
						<span v-else-if="isToRenderOfficialProcessingIcon(propertie)">
							<OfficialProcessingIcon
								:inventario-oficial="dataObject.inventarioOficial"
								:is-list-view="true"
							/>
						</span>

						<span v-else>
							{{ dataValue || '' }}
						</span>
					</td>

					<td
						:id="dataObject.id"
						class="container__normaltable__botaoeditar"
					>
						<slot
							name="action-button"
							v-bind="dataObject"
						/>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Checkbox from '../../Checkbox/Checkbox'
import ProgressBar from '../../ProgressBar/ProgressBar'
import Tag from '../../Tag/Tag'
import OfficialProcessingIcon from '../../OfficialProcessingIcon/OfficialProcessingIcon'

import _ from 'lodash'

export default {
	components: { Checkbox, ProgressBar, Tag, OfficialProcessingIcon },
	props: {
		showSortOptions: {
			type: Boolean,
			default: false,
		},
		isOfficial: {
			type: Boolean,
			default: false,
		},
		/**
		 * Diz para o componente que ele está sendo utilizado em relatórios, assim
		 * é possível ocultar elementos de tela que demandam ação do usuário
		 */
		reportMode: {
			type: Boolean,
			default: false,
		},
		/**
		 * Lista de objetos que servirão de header para a tabela, prop obrigatória, com a sintaxe de: {key: 'foo', value: 'bar'}
		 */
		headers: {
			type: Array,
			required: true,
		},
		/**
		 * mostrar botoes de os
		 */
		isOS: { type: Boolean, default: false },
		/**
		 * mostrar botao de editar
		 */
		mostrarBtnEditar: { type: Boolean, default: true },
		/**
		 * Dados da tabela
		 */
		data: Array,
		/**
		 * Configuracoes da tabela
		 */
		tableConfiguration: Object,
		/**
		 * Funcao para exibir o modal de edicao
		 */
	},
	data: () => {
		return {
			valor: '',
			sortBy: undefined,
			sortType: undefined,
			/**
			 * Bind para exbluir todos os registros da pagina atual
			 */
			isDeleteAllPageData: false,
		}
	},
	computed: {
		headersFiltered() {
			return this.headers.filter((f) => f.isActive)
		},
		// /**
		//  * Retorna as propriedades do objeto para serem mapeadas com os valores do header
		//  */
		// headers() {
		//   if (this.data.length !== 0) {
		//     return this.tableConfiguration.headers
		//       .filter((f) => f.isActive)
		//       .map((m) => m.key);
		//   } else {
		//     return [];
		//   }
		// },
	},
	watch: {
		/**
		 * Watcher para setar os dados da pagina atual para excluir
		 */
		isDeleteAllPageData(value) {
			this.data.forEach((f) => {
				if (value) {
					if (!f.isBlocked) {
						f.isCheckedToDelete = value
					}
				} else {
					f.isCheckedToDelete = value
				}
			})
		},
	},
	methods: {
		changeSort(sortBy, sortType) {
			this.sortBy = sortBy
			this.sortType = sortType

			if (this.sortBy === 'eifl_dt_processamento') {
				this.$emit('sortConfigDate', { sortBy, sortType })
				return
			}

			this.$emit('sortConfig', { sortBy, sortType })
		},

		/**
		 *
		 * Retorna o nome do header que deve ser exibido na tabela
		 */
		getHeaderValue(headerPropertie) {
			const headerValue = this.tableConfiguration.headers.find(
				(f) => f.key === headerPropertie,
			).value
			return headerValue
		},
		/**
		 * Retorna o objeto apenas com as propriedades que foram mapeadas na configuracao do headers
		 */
		getPropertiesMapped(data) {
			return _.pick(
				data,
				this.headers.filter((f) => f.isActive).map((m) => m.key),
			)
		},
		/**
		 * Verifica se e para ser renderizado uma tag
		 */
		isToRenderATag(propertie) {
			if (this.tableConfiguration?.tags) {
				return this.tableConfiguration.tags[propertie] ? true : false
			}
			return false
		},
		isToRenderOfficialProcessingIcon(propertie) {
			if (propertie === 'inventarioOficial') {
				return true
			}
			return false
		},
		/**
		 * Verifica se e para ser renderizado uma barra de progresso
		 */
		isToRenderAProgressBar(propertie) {
			if (this.tableConfiguration?.progressBar) {
				return this.tableConfiguration.progressBar.some((progress) => progress === propertie)
			}
			return false
		},
		isToRenderAColorIndicator(propertie) {
			if (this.tableConfiguration?.colorIndicator) {
				return this.tableConfiguration.colorIndicator.some((color) => color === propertie)
			}
			return false
		},
	},
}
</script>

<style scoped>
.container__normaltable {
	width: 100%;
	text-align: center;
	margin-top: 1rem;
	font-size: 0.75rem;
	overflow-x: auto;
	color: var(--color-gray-dark);
}

.container__normaltable__empty {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 2rem;
	font-size: 0.875rem;
	color: var(--color-gray-dark);
}

table {
	width: 100%;
	border-collapse: collapse;
}

table tr {
	page-break-inside: avoid;
}

tr {
	background-color: #fafbfd;
	border: 1.2px solid #e4e4e5;
	height: 2.5rem;
}

tbody tr:nth-child(1n) {
	background-color: white;
	page-break-inside: avoid;
}
tbody tr:nth-child(2n) {
	background-color: #fafbfd;
	page-break-inside: avoid;
}
td {
	padding: 0.2rem 0.5rem;
}

thead {
	font-weight: 700;
	color: rgb(var(--color-primary));
}

.container__normaltable__tags {
	display: inline-block;
}

.container__normaltable__botaoeditar {
	display: flex;
	justify-content: flex-end;
}
</style>
